import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { memo, useRef } from 'react';
import useViewbox from '../../useViewbox.js';
const SvgSuccessFilled = memo((componentProps) => {
    const ref = useRef(null);
    useViewbox(ref);
    const props = {
        ...componentProps,
        ref,
        className: 'spriteIcon'
    };
    return (_jsx("svg", { role: "presentation", viewBox: "0 0 14 14", ...props, children: _jsxs("g", { fill: "none", fillRule: "evenodd", children: [_jsx("circle", { cx: 7, cy: 7, r: 7, fill: "#79c926", className: "primary-color" }), _jsx("path", { fill: "#fff", fillRule: "nonzero", d: "m10.243 4a.718.718 0 0 0 -.506.236l-3.75 3.956-1.8-1.47a.712.712 0 0 0 -1.034.141.807.807 0 0 0 .133 1.09l2.313 1.886c.293.238.708.21.97-.066l4.207-4.438a.808.808 0 0 0 .166-.86.736.736 0 0 0 -.699-.475z", className: "secondary-color" })] }) }));
});
export default SvgSuccessFilled;
//# sourceMappingURL=SuccessFilled.js.map